/** @jsx React.DOM */
var React = require('react/addons')
var Router = require('react-router')
var Route = Router.Route
var Routes = Router.Routes
var Link = Router.Link
var Nav = require('./partials/nav')
var Footer = require('./partials/footer')
var constants = require('./helpers/constants')

window.Remotes = require('./helpers/remotes')
document.originalTitle = document.title

// Expose React to React debugger
window.React = React

var App = React.createClass({displayName: 'App',
  render: function() {
    return (
      React.DOM.div(null, 
        Nav(null), 
        this.props.activeRouteHandler(), 
        Footer(null)
      )
    )
  }
})

var HomeRoute = require('./routes/home')
var RippleHomeRoute = require('./routes/wrt/home')
var RippleAccountRoute = require('./routes/wrt/account')
var RippleTransactionRoute = require('./routes/wrt/transaction')

var routes = (
  Routes(null, 
    Route({handler: App}, 
      Route({name: "home", path: "/", handler: HomeRoute}), 
      Route({name: "rippleHome", path: "/wrt", handler: RippleHomeRoute}), 
      Route({name: "rippleAccount", path: "/wrt/accounts/:account", handler: RippleAccountRoute}), 
      Route({name: "rippleTransaction", path: "/wrt/transactions/:hash", handler: RippleTransactionRoute})
    )
  )
)

React.renderComponent(routes, document.body)



//////////////////
// WEBPACK FOOTER
// ./src/Application.jsx
// module id = 4
// module chunks = 0